var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2363_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4628 0.263826L0.263672 10.4629L1.53644 11.7357L11.7355 1.53659L10.4628 0.263826Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17589 6.35304C7.61901 6.35304 6.35254 7.61977 6.35254 9.17665C6.35254 10.7335 7.61927 12 9.17589 12C10.733 12 11.9995 10.7335 11.9995 9.17665C11.9995 7.61953 10.7328 6.35304 9.17589 6.35304ZM9.17589 10.2002C8.61166 10.2002 8.15254 9.74112 8.15254 9.17689C8.15254 8.61242 8.61166 8.15328 9.17589 8.15328C9.74036 8.15328 10.1995 8.61239 10.1995 9.17689C10.1995 9.74112 9.74038 10.2002 9.17589 10.2002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82337 5.64673C4.38002 5.64673 5.64673 4.38 5.64673 2.82337C5.64673 1.26647 4.38 0 2.82337 0C1.26649 0 0 1.26647 0 2.82335C0 4.38023 1.26649 5.64673 2.82337 5.64673ZM2.82337 1.8C3.38761 1.8 3.84673 2.25912 3.84673 2.82335C3.84673 3.38759 3.38761 3.8467 2.82337 3.8467C2.25914 3.8467 1.80002 3.38782 1.80002 2.82335C1.8 2.25912 2.25912 1.8 2.82337 1.8Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2363_643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.e38f84fbef86c0068fd694bd375f7fdc.svg";
export { ForwardRef as ReactComponent };